
import * as d3 from 'd3';

const simpleStackedBar = function (opts) {
    this.data = opts.data;
    this.maxval = opts.maximum_value || this.setMaxVal();
    this.injectionPoint = opts.bindTo; //WARNING: MUST BE D3.SELECT() OBJECT
    this.default_colors =  ["#87D498", "#9F85C6", "#829DC2", "#EF786C", "#FFDB9E", "#9ecbff", "#ffbc9e", "#ff9ef5"];
    this.axis_color = opts.axis_color || 'white';
    this.width = opts.width || 300;
    this.height = opts.height || 60;
    this.padding = this.width * .2;

    //sets color of background space (at .2 opacity) and color of ticks (at full opacity)
    this.trackcolor = "#829DC2";
    //how much space to put in between bars.
    this.barPadding = 2;

    //clean data -- ensure value is int and not zero.
    this.data.forEach(function(d){
        d.value = Math.round(d.value);
    })

    this.data = this.data.filter(function(d) {
        return d.value > 0;
    })

    this.draw();
}



simpleStackedBar.prototype.setMaxVal = function() {
  return this.data.reduce(function(a, b) { return a + b.value }, 0)
}


simpleStackedBar.prototype.setScales = function() {

   this.x = d3.scaleLinear()
              .range([0 , this.width])
              .domain([0, this.maxval])
}


simpleStackedBar.prototype.draw = function() {
  const _this = this;
  _this.svg = _this.injectionPoint
        .append('svg')
        .attr("viewBox", "0 0 340 100")
        .append('g')
        .classed("chart-wrapper", true)
        .attr("transform", "translate(20,20)");


  //set y scale and draw right axis;
  _this.setScales();

  //now go ahead and create blocks and bind data

  _this.blocks = _this.svg
                .append('g')
                .attr('class', 'blocks')


  //this function is dependent on _this.blocks to draw the track.
    //must also trigger before blockset draw, or hover over will not work (because the track will be on top of the other blocks)
  _this.drawBaseline();


 _this.blockset =  _this.blocks.selectAll('.block')
          .data(_this.data).enter()
          .append('g').classed('block', true)


   _this.blockset.append('rect')
          .attr('y', 4)
          .attr('x', function(d, i) {
              return _this.x(_this.data.slice(0,i).reduce(function (a,b) { return a + b.value}, 0)) + (_this.barPadding * i)})
          .attr('width', function(d) { return _this.x(d.value); })
          .attr('height', _this.height - 10)
          .attr('fill', function(d, i) { if (d.color) { return d.color} else {return _this.default_colors[i] } })
          .attr('rx', 4)
          .attr('ry', 4);

  _this.appendLabels();
  

}



simpleStackedBar.prototype.appendLabels = function() {
  const _this = this;

  //build text attributes by harvesting rect attibutes.
  let text =  _this.blockset.append('text')

  text
      .attr("transform", function() {
            var t = d3.select(this);
            var trect = d3.select(this.parentNode).select('rect');
            var y = parseInt(trect.attr('height'))/2 + parseInt(trect.attr('y'));
            var x = parseInt(trect.attr('width'))/2 + parseInt(trect.attr('x'))
             return "translate(" + x.toString() + "," + y.toString() + ") rotate(-90)"
          } )

      .attr('fill', function(d) { return d3.hsl(d.color).brighter(1.5) } )
      .attr('text-anchor', 'middle')
      .attr('font-size', 12)
      .attr('dy', 5)
      .text(function(d) { return d.label})

  //append hover listeners //


  _this.blockset.on('mouseenter', function(d){
    const percentage = d.value/_this.maxval * 100;
    d3.select(this).select('text').text(d.value);

  });
    _this.blockset.on('mouseout', function(d){
    d3.select(this).select('text').text(d.label);
  });

}




simpleStackedBar.prototype.drawBaseline = function() {
  const _this = this;


  //if there is no maximum value, don't draw a baseline
  if (!_this.maxval) return;

  //create axes. We have to reset the range to accomodate padding between bars.
    const adjustedx = _this.x.copy().range([0, _this.width + _this.data.length * _this.barPadding]);

    //first we draw the track
    _this.track = _this.blocks.append('rect')
        .attr('y', 4)
        .attr('x', 0)
        .attr('width', function () { return adjustedx(_this.maxval);  })
        .attr('height', _this.height - 10)
        .attr('fill', this.trackcolor)
        .attr('opacity', .2)
        .attr('rx', 4)
        .attr('ry', 4);
    
    //now we draw the axes. We hide everything but the ticks.
  _this.axisBottom = d3.axisBottom(adjustedx)

  if (_this.setMaxVal() < _this.maxval && (_this.maxval/100) - (_this.setMaxVal()/100) > .07) {
      _this.axisBottom.tickValues([_this.setMaxVal(), _this.maxval]).tickSizeInner(-_this.height);
  } else {
    _this.axisBottom.tickValues([_this.maxval]).tickSizeInner(-_this.height);
  }

  _this.svg.append('g')
            .classed('axis-wrapper', true)
            .attr('transform', 'translate('+ 0 + ',' + _this.height  + ')')
            .call(_this.axisBottom);

  d3.selectAll('.tick').select('text').style('font-size', '14px').style('fill', this.trackcolor);
  d3.selectAll('.domain')
                    .style("opacity", 0)
  d3.selectAll('.tick').select('line').style("stroke", this.trackcolor);

}



export default simpleStackedBar;
